import * as Yup from "yup";
import { campo_obligatorio } from "../../utils/traductor";

export function initialValues(state) {
  return {
    tipo: state.tipo,
    idioma: state.idioma,
    texto: state.texto,
    activo: state.activo,
  };
}

export function validationSchema() {
  return Yup.object({
    tipo: Yup.string().required(` ${campo_obligatorio} `),
    idioma: Yup.string().required(` ${campo_obligatorio} `),
    texto: Yup.string().required(` ${campo_obligatorio} `),
  });
}
